import { ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TIconProps } from '@/common/components/Icons/Icon';
import { RouterLink } from '@/common/components/RouterLink/RouterLink';
import { ROUTES } from '@/common/constants/routes';
import { IBenefit } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import { tArray } from '@/common/utils/i18n';
import {
  Button,
  Flex,
  IconCoverflexApp,
  IconCreditCard,
  Text,
} from '@coverflex-tech/hypernova';
import { css } from './SucFringeLC.css';

interface IProps {
  benefit: IBenefit;
}

export const SucFringeLCContent = ({ benefit }: IProps) => {
  const { t } = useTranslation();

  const examplePoints =
    tArray<string>(
      `learning_centre.italy-fringe.${benefit?.slug}.example.points`
    ) ?? [];

  const iconMap: Record<string, ReactElement<TIconProps>> = {
    contribution: <IconCoverflexApp className={css.icon} />,
    voucher_card: <IconCreditCard className={css.icon} />,
  };

  const icon = iconMap[benefit.products[0]!.type] || null;

  return (
    <div className={css.content}>
      <Flex flexDirection="column">
        <Text bold className={css.title}>
          {t(`learning_centre.italy-fringe.${benefit.slug}.example.title`)}
        </Text>
        <Trans
          i18nKey={`learning_centre.italy-fringe.${benefit.slug}.example.description`}
        />
        <ul className={css.bulletList}>
          {Array.isArray(examplePoints) &&
            examplePoints.map((point) => (
              <li className={css.bullet} key={point}>
                {point}
              </li>
            ))}
        </ul>
        <Trans
          i18nKey={`learning_centre.italy-fringe.${benefit.slug}.example.explanation`}
        />
      </Flex>
      <Flex flexDirection="column">
        <Text bold className={css.title}>
          {t(`learning_centre.italy-fringe.${benefit.slug}.card.title`)}
        </Text>
        <Flex gap="sm" alignItems="center" className={css.containerCard}>
          {icon}
          <Text bold color="neutral20">
            {t(
              `learning_centre.italy-fringe.${benefit.slug}.card.coverflex_card`
            )}
          </Text>
        </Flex>
        <Text>
          <Trans
            i18nKey={`learning_centre.italy-fringe.${benefit.slug}.card.description`}
          />
        </Text>
        <RouterLink
          href={{
            pathname: ROUTES.WELFARE_CATEGORIES,
            params: { slug: benefit?.slug },
          }}
          className={css.link}
        >
          <Button variant="tertiary" presentational size="sm">
            {t(`learning_centre.italy-fringe.${benefit?.slug}.example.link`)}
          </Button>
        </RouterLink>
      </Flex>
    </div>
  );
};
